import { render, staticRenderFns } from "./infoViewDialog.vue?vue&type=template&id=3b8b4beb&scoped=true&"
import script from "./infoViewDialog.vue?vue&type=script&lang=js&"
export * from "./infoViewDialog.vue?vue&type=script&lang=js&"
import style0 from "./infoViewDialog.vue?vue&type=style&index=0&id=3b8b4beb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8b4beb",
  null
  
)

export default component.exports